<template>
    <img v-if="isCurrency" class="image" :alt="resource.name" :src="currencyIcon">
    <img v-else class="image" :alt="resource.name" :src="resource.iconUrl">
</template>

<script>
    import Currencies from "@/currencies"

    export default {
        name: 'ResourceImage',
        components: {
        },
        props: {
            resource: {
                required: true
            }
        },
        computed: {
            isCurrency() {
                return this.resource.type === "currency";
            },
            currencyIcon() {
                return Currencies.currencyIcons[this.resource.name];
            }
        }
    }
</script>

<style scoped>
</style>
